import React from "react";
import { HomeContentPiece, HomeComponentProps } from "./Pieces";
import { useHomePresentation } from "./Hooks";
export default function HomeComponent(props: HomeComponentProps) {
  const presentation = useHomePresentation(props.homePageData);
  return <HomeContentPiece {...props} presentation={presentation} />;
}
